import {
	Button,
	IconButton,
	useMediaQuery,
} from "@mui/material";
import React, { useContext } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useIntl } from "react-intl";
import {
	BusinessDataContext,
	BusinessDataContextValues,
	LoginContext,
	LoginContextValues,
	MultistepContext,
	MultistepContextValues,
} from "../../types/context";
import { findComponentStep } from "../../utils/filter";
import { theme } from "../../styles/themeProvider";
import { useNavigate } from "react-router-dom";

export const BackButton = () => {
	const { formatMessage } = useIntl();
	const { selectedFlow } = useContext(
		BusinessDataContext
	) as BusinessDataContextValues;

	const {
		reservation,
		onChangeStep,
		onPrev,
		activeStep,
		onChangeLogin,
		reservationMade,
		onReset,
	} = useContext(MultistepContext) as MultistepContextValues;

	const { isCalledFromProfile, isLogged, onLogout } = useContext(
		LoginContext
	) as LoginContextValues;

	const isSmall = useMediaQuery(theme.breakpoints.down("xs"));

	const detailsStep = findComponentStep(selectedFlow!, "Details");
	const profileStep = findComponentStep(selectedFlow!, "Profile");
	const registerStep = findComponentStep(selectedFlow!, "Register");
	const changePasswordStep = findComponentStep(selectedFlow!, "ChangePassword");
	const forgotPasswordStep = findComponentStep(
		selectedFlow!,
		"RecoverPassword"
	);
	let loginStep = findComponentStep(selectedFlow!, "Login");

	const navigate = useNavigate();
	const clearUrlParams = () => {
		navigate("/");
	};

	const handlePrev = () => {
		// If we're in the Forgot Passord step and we're in the reservation (not profile)
		// then, I come back to the Login step, if we're in the register step we do the same
		if (activeStep === forgotPasswordStep || activeStep === registerStep) {
			if (isCalledFromProfile) {
				loginStep = findComponentStep(selectedFlow!, "LoginFromProfile");
			}
			if (isLogged) onLogout(onChangeLogin);
			onChangeStep(loginStep);
		} else if (
			activeStep === profileStep ||
			(activeStep === detailsStep && reservationMade)
		) {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const paymentId = urlSearchParams.get("external_reference");
			if (paymentId) {
				clearUrlParams();
			}
			onReset();
			onChangeStep(0);
			// If we're changing the password and we're already logged in, the previous step will be profile
		} else if (activeStep === changePasswordStep && reservation.customer.id) {
			onChangeStep(profileStep);
		} else {
			// If we want to go prev, and the previous component is Login and we are logged,
			// we redirect to the previous component of login
			if (activeStep - 1 === loginStep && isLogged) {
				onChangeStep(activeStep - 2);
			} else {
				onPrev();
			}
		}
	};

	return isSmall ? (
		<IconButton
			size="small"
			sx={{
				position: "absolute",
				left: 20,
				top: 28,
			}}
			onClick={handlePrev}
		>
			<ArrowBackIosNewIcon fontSize="small" sx={{ pb: "4px" }} />
		</IconButton>
	) : (
		<Button
			size="small"
			variant="text"
			onClick={handlePrev}
			sx={{
				position: "absolute",
				fontWeight: "regular",
				textDecoration: "none",
				left: 28,
				top: 28,
			}}
			startIcon={<ArrowBackIosNewIcon sx={{ pb: "4px" }} />}
		>
			{formatMessage({
				id: "home.back",
				defaultMessage: "Atrás",
			})}
		</Button>
	);
};
